<div class="grid-container">
	<h3 class="full-row">{{'Digital photos' | translate}}</h3>
	<h3 class="full-row">extraoral</h3>
	<div class="extraoral-container" [ngStyle]="{'--numImagesExtra': ExtraoralImages.length}">
		@for (item of ExtraoralImages; track item.id) {
			<ng-container
				[ngTemplateOutlet]="mediaBox"
				[ngTemplateOutletContext]="{item: item}"
			>
		    </ng-container>
		}
	</div>
	<h3 class="full-row">intraoral</h3>
	<div class="intraoral-container" [ngStyle]="{'--numImagesIntra': IntraoralImages.length}">
		@for (item of IntraoralImages; track item.id) {
			<ng-container
				[ngTemplateOutlet]="mediaBox"
				[ngTemplateOutletContext]="{item: item}"
			>
		    </ng-container>
		}
	</div>
	<h3 class="full-row">{{'X-ray' | translate}}</h3>
	<div class="misc-container" [ngStyle]="{'--numImagesMisc': MiscellaneousImages.length}">
		@for (item of MiscellaneousImages; track item.id) {
			<ng-container
				[ngTemplateOutlet]="mediaBox"
				[ngTemplateOutletContext]="{item: item}"
			>
		    </ng-container>
		}
	</div>
</div>
<p class="info"><i class="fas fa-info-circle"></i> {{'Erlaubte Dateiformate' | translate}} jpg, jpeg, png /
	{{'Röntgenbild' | translate}}: jpg, jpeg, png, dcm, dcm30
</p>

<ng-template #mediaBox let-item="item">
	<media-file-upload-box
	id="{{item.id}}"
		[ngStyle]="hasAlternatingAssets(item.id) ? {'background-image': 'url(' + getBackgroundImage(item.id) + ')'} : null"
		[params]="{treatment: null, patientId: patientId, uploadType: item.id}"
		[allowed_extensions]="item.allowed_extensions"
		[allowed_max_size]="item.allowed_max_size"
		[attachedFile]="getMediaModelForId(item.id)"
		[uploadRequired]="item.required"
		[isAllowedToRemoveFile]="true"
		(fileEvent)="onFileEvent($event, item.id)">
		<p class="description">{{item.description | translate}}</p>
	</media-file-upload-box>
</ng-template>
